import { render, staticRenderFns } from "./AddOrEditMenu.vue?vue&type=template&id=0db1fdad&scoped=true&"
import script from "./AddOrEditMenu.vue?vue&type=script&lang=js&"
export * from "./AddOrEditMenu.vue?vue&type=script&lang=js&"
import style0 from "./AddOrEditMenu.vue?vue&type=style&index=0&id=0db1fdad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db1fdad",
  null
  
)

export default component.exports